type Mods = Record<string, boolean | string>

export const cls = (cls: string, mods: Mods = {}, additional: string[] = []): string => [
    cls,
    ...additional,
    ...Object.entries(mods)
        .filter(([className, value]) => Boolean(value))
        .map(([className]) => className),
]
    .join(' ');